import React from 'react';
import PropTypes from 'prop-types';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';
import RequestedAuthorizationFields from './RequestedAuthorizationFields';

const InReviewAuthorizationFields = ({ authorization }) => (
  <>
    <RequestedAuthorizationFields
      authorization={authorization}
      notesContent={authorization.update_request_note}
    />
    <AuthorizationHistoryLineItem field="Review Note">
      {authorization.in_review_note ? (
        <div className="whitespace-pre-line">{authorization.in_review_note}</div>
      ) : (
        'N/A'
      )}
    </AuthorizationHistoryLineItem>
  </>
);

InReviewAuthorizationFields.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

export default InReviewAuthorizationFields;
